import { useState } from "react";
import { signIn } from "../../services/supabase-auth.service";

export function LoginPanel({
	onSuccess,
	onSwitchToSignup,
	error: externalError,
}: {
	onSuccess: () => void;
	onSwitchToSignup: () => void;
	error?: string;
}) {
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [error, setError] = useState("");
	const [loading, setLoading] = useState(false);

	async function submit(e: React.FormEvent) {
		e.preventDefault();
		setError("");
		setLoading(true);
		try {
			await signIn(email, password);
			onSuccess();
		} catch (err) {
			setError(err instanceof Error ? err.message : "Đăng nhập thất bại.");
		} finally {
			setLoading(false);
		}
	}

	const displayError = error || externalError;

	return (
		<div className="auth-card">
			<span className="brand-mark">G</span>
			<p className="eyebrow">Gout Food Scanner</p>
			<h1>Đăng nhập</h1>
			<p>Chụp món ăn và nhận đánh giá phù hợp cho người bị gout.</p>
			{displayError && (
				<div className="error" role="alert">
					{displayError}
				</div>
			)}
			<form onSubmit={submit} className="auth-form">
				<label className="auth-field">
					Email
					<input
						value={email}
						onChange={(e) => setEmail(e.target.value)}
						type="email"
						placeholder="ban@example.com"
						autoComplete="email"
						required
					/>
				</label>
				<label className="auth-field">
					Mật khẩu
					<input
						value={password}
						onChange={(e) => setPassword(e.target.value)}
						type="password"
						placeholder="••••••••"
						autoComplete="current-password"
						required
					/>
				</label>
				<button type="submit" className="primary auth-button" disabled={loading}>
					{loading ? "Đang đăng nhập…" : "Đăng nhập"}
				</button>
			</form>
			<button type="button" className="auth-switch" onClick={onSwitchToSignup}>
				Chưa có tài khoản? Đăng ký
			</button>
		</div>
	);
}
